"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "role-schedule-timeline-scroll" };
const vue_3 = require("vue");
const RoleTimeRow_vue_1 = __importDefault(require("./RoleTimeRow.vue"));
const RoleTimeFooter_vue_1 = __importDefault(require("./RoleTimeFooter.vue"));
const roleTimeLayout_1 = require("../roleTimeLayout");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleTimeView',
    props: {
        role: {},
        branchSettings: {}
    },
    emits: ["timelineHeight"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const timeRange = (0, vue_3.computed)(() => ({
            start: props.branchSettings?.getSummaryDayStart() ?? 0,
            end: props.branchSettings?.getSummaryDayEnd() ?? 24,
        }));
        const timelineHeight = (0, vue_3.computed)(() => {
            const layout = (0, roleTimeLayout_1.calculateRoleTimeLayout)(props.role.roleSections, timeRange.value);
            return Math.max((0, roleTimeLayout_1.calculateRoleTimeHeight)(layout.laneCount) + roleTimeLayout_1.ROLE_TIME_FOOTER_HEIGHT, roleTimeLayout_1.CONTAINER_HEIGHT);
        });
        (0, vue_3.watch)(timelineHeight, (newHeight) => {
            emits("timelineHeight", newHeight);
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: "role-schedule-timeline",
                style: (0, vue_2.normalizeStyle)({ minHeight: `${timelineHeight.value}px` })
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(RoleTimeRow_vue_1.default, {
                        role: __props.role,
                        "time-range": timeRange.value
                    }, null, 8 /* PROPS */, ["role", "time-range"]),
                    (0, vue_2.createVNode)(RoleTimeFooter_vue_1.default, {
                        "start-hour": timeRange.value.start,
                        "end-hour": timeRange.value.end
                    }, null, 8 /* PROPS */, ["start-hour", "end-hour"])
                ])
            ], 4 /* STYLE */));
        };
    }
});
